module.exports = __webpack_public_path__ + "img/TV.899f891e.png";